import { render, staticRenderFns } from "./ToolDetail.vue?vue&type=template&id=1fcc0d08&scoped=true"
import script from "./ToolDetail.vue?vue&type=script&lang=js"
export * from "./ToolDetail.vue?vue&type=script&lang=js"
import style0 from "./ToolDetail.vue?vue&type=style&index=0&id=1fcc0d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc0d08",
  null
  
)

export default component.exports